export default (that) => [
  {
    text: that.$l('menu_text_detail') || '查看详情',
    icon: 'el-icon-view',
    menuType: 'detail',
  },
  {
    text: that.$l('menu_text_review') || '审核需求',
    icon: 'el-icon-check',
    menuType: 'review',
    divided: true,
    allow: 'R',
  },
]
